import { parseTweddleDomain } from 'lib/domain/parseTweddleDomain'

const _parsed = parseTweddleDomain(window.location.hostname)

function _deriveServerUrl(): string {
  if (_parsed) {
    const { app, mode, clientCode, env } = _parsed
    const protocol = window.location.protocol
    const host = env
      ? `${clientCode}.${mode}.backend.${app}.${env}.gd.tweddle.tech`
      : `${clientCode}.${mode}.backend.${app}.gd.tweddle.io`
    return `${protocol}//${host}`
  }
  if (import.meta.env.VITE_SERVER_URL) return import.meta.env.VITE_SERVER_URL
  return `http://${window.location.hostname}:3093`
}

export const SERVER_URL: string = _deriveServerUrl()
export const CLIENT_CODE: string | null = _parsed?.clientCode ?? null
